import React from "react";

/**
 * Labelled numeric field shared by the Seat and Pay As You Go pricing modals, so both
 * forms render identical label / required marker / placeholder / help-text / error markup.
 *
 * Presentational only: the caller supplies `value`, `error`, `onChange` and `inputRef`.
 * (`max` is optional and omitted from the DOM when undefined, so the Seat modal - which
 * never passes it - renders exactly as before.)
 */
const FormGroup = ({
  label,
  name,
  type = "number",
  min = "0",
  max,
  step = "1",
  required = true,
  helpText,
  icon,
  value,
  error,
  onChange,
  inputRef
}) => (
  <div className="form-group">
    <label htmlFor={name} className="form-label">
      {icon && <i className={`fa ${icon} me-2 mr-2`}></i>}
      {label}
      {required && <span className="text-danger ms-1">*</span>}
    </label>
    <input
      type={type}
      className={`form-control ${error ? 'is-invalid' : ''}`}
      ref={inputRef}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      required={required}
      placeholder={`Enter ${label.toLowerCase()}`}
    />
    {helpText && <div className="form-text">{helpText}</div>}
    {error && <div className="invalid-feedback">{error}</div>}
  </div>
);

export default FormGroup;
